module.exports = __webpack_public_path__ + "static/media/rectangle-13.b348c8c5.svg";